import { uploadFile, callApi } from 'services/config';

export const uploadFileService = async (file: File) => {
  return await uploadFile('/files', 'post', file, {});
};

export const uploadMultipleFilesService = async (files: File[], companyId: string) => {
  // Create FormData to send files and parameters
  const formData = new FormData();

  // Append each file to the formData with the same parameter name "files"
  files.forEach((file) => {
    formData.append('files', file);
  });

  // Add the required parameters
  formData.append('companyId', companyId);

  // Call the multiple files upload endpoint
  return await callApi('/files/multiple', 'post', formData);
};

export const uploadNoticesService = async (files: File[], companyId: string) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  formData.append('companyId', companyId);
  return await callApi('/files/notices', 'post', formData);
};

export const downloadFileService = async (contractID: string) => {
  return await callApi(`/contracts/${contractID}/fileUrl`, 'get', {
    contractID,
  });
};

export const getFileURL = async (fileId: string) => {
  return await callApi(`/files/${fileId}`, 'get', {});
};
